var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "73d9263ac5453078b850ad520bfa22793a15a2c9"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["icloudready-newwebsite@icloudready"] = {
  id: "73d9263ac5453078b850ad520bfa22793a15a2c9"
};